import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
 
// 用来存储数据
const state = {
    topHeight:0,//页面滚动距离
    navType:1, //navbar 选中模块,
    pageId:'',//锚点定位id
}
// 响应组件中的事件
const actions = {
}
// 操作数据
const mutations = {
    saveTopHeight(state, message) {//页面滚动距离
        state.topHeight = message
    },
    saveNavType(state, message) { //navbar 选中模块
        state.navType = message
    },
    savePageId(state, message) { //锚点定位id
        state.pageId = message
    },
}
// 用来将state数据进行加工
const getters = {
}
// 新建并暴露store
export default new Vuex.Store({
    state,
    actions,
    mutations,
    getters
})
 


// WEBPACK FOOTER //
// ./src/store/index.js